// extracted by mini-css-extract-plugin
module.exports = {"details":"tableItem_details__b1jGR"};